import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlMatiFieldsFragment = { id: string, order: number, subjectPrimaryLang: string, subjectSecondaryLang: string, commentPrimaryLang?: string | null, commentSecondaryLang?: string | null, decisionPrimaryLang?: string | null, decisionSecondaryLang?: string | null, mandatory: boolean, firstGroup: boolean, lastGroup: boolean, kind: Types.GqlAgendaItemKind, meetingAgendaTemplateId: string, createdAt: string, updatedAt: string };

export const MatiFieldsFragmentDoc = gql`
    fragment MatiFields on MeetingAgendaTemplateItem {
  id
  order
  subjectPrimaryLang
  subjectSecondaryLang
  commentPrimaryLang
  commentSecondaryLang
  decisionPrimaryLang
  decisionSecondaryLang
  mandatory
  firstGroup
  lastGroup
  kind
  meetingAgendaTemplateId
  createdAt
  updatedAt
}
    `;